import React from 'react';
import classNames from 'classnames';
import { Lead } from 'models/Lead';
import { useTranslation } from 'react-i18next';
import usePastTime from 'hooks/usePastTime';
import {
  ChatCellComponent,
  DocumentsCellComponent,
  NdaCellComponent,
} from '../../../LeadsTableContainer/components/LeadsTableCell';
import NewBadge from '../../../NewBadge';
import LeadContext from '../../../LeadCard/components/LeadContext';
import useLead from '../../../../hooks/useLead';
import { getUserFullName } from 'utils';

import './LeadMobileCard.styles.scss';

type LeadMobileCardProps = {
  className?: string;
  lead: Lead;
  onClick: () => void;
  updateLead: (lead: Lead) => void;
};

const LeadMobileCard: React.FC<LeadMobileCardProps> = (props) => {
  const { className, lead, onClick, updateLead } = props;

  const {
    lastSeen,
    context,
    buyer: { companyName, firstName, lastName },
  } = lead;

  const { t } = useTranslation();

  const pastTime = usePastTime()(lastSeen);

  const { getIsNew, getBackgroundColor } = useLead();

  const isNew = getIsNew(lead);

  const backgroundColor = getBackgroundColor(lead);

  const classes = classNames(
    'lead-mobile-card',
    'white-panel',
    backgroundColor,
    className,
  );

  return (
    <div className={classes} onClick={onClick}>
      <div>
        <p className="name">{getUserFullName(firstName, lastName)}</p>

        <div className="lead-mobile-card__badges">
          <NdaCellComponent lead={lead} updateLead={updateLead} />
          {isNew && <NewBadge />}
        </div>
      </div>

      <div>
        {companyName && <p>{companyName}</p>}
        <ChatCellComponent lead={lead} />
      </div>

      <DocumentsCellComponent lead={lead} />

      <LeadContext context={context} />

      {pastTime && <p>{t('lastSeenDate', { date: pastTime })}</p>}
    </div>
  );
};

export default LeadMobileCard;
